exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-info[data-v-75ca324c]{margin:10px 0;padding:10px;border:1px solid #eee;border-radius:4px;background-color:#f8f8f8}.v-btn[data-v-75ca324c]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75ca324c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/bank-products/BankingProductsLoadFile.vue
// module id = hCUX
// module chunks = 0